import { useEffect, useState, useCallback, useRef } from 'react';

import { SocketManager, type SocketStatus } from '../services/SocketManager';

export function useSocketEvent(
  event: string,
  handler: (...args: any[]) => void,
  options?: { room?: string; enabled?: boolean }
) {
  const handlerRef = useRef(handler);
  handlerRef.current = handler;

  useEffect(() => {
    if (options?.enabled === false) return;

    const stableHandler = (...args: any[]) => handlerRef.current(...args);

    const unsubscribe = SocketManager.subscribe(event, stableHandler, {
      room: options?.room,
    });

    return unsubscribe;
  }, [event, options?.room, options?.enabled]);
}

export function useSocketStatus() {
  const [status, setStatus] = useState<SocketStatus>(SocketManager.status);

  useEffect(() => {
    return SocketManager.onStatusChange(setStatus);
  }, []);

  return status;
}

export function useSocketEmit() {
  return useCallback((event: string, ...args: any[]) => {
    SocketManager.emit(event, ...args);
  }, []);
}
